import React from 'react';
import {
  string, number, bool, func, object,
} from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';
import isNil from 'lodash/isNil';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';
import Locale from '@active/react-utils/i18n/Locale';
import Responsive from '@active/react-utils/components/Responsive';
import Popover from '@active/react-ui/Popover';
import Currency from '../../Currency';
import { handleKeyboardEvent } from '../../../../shared/utils/commonUtils';

const AmountField = ({
  label, price, currencyCode,
  className, tipId, name, isShowTipMsg,
  toggleShowTipMsg, placement,
  handleMouseOver, isShowBlankCol,
  labelSpanConfig, valueSpanConfig, blankColSpanConfig,
}) => {
  const labelContent = label ? <Locale id={label}/> : name;
  const amountStyleClassName = price < 0 ? ' red-amount' : '';
  const TipText = () => {
    return tipId ? <span id={`field-label__${tipId}`}>{labelContent}</span> : labelContent;
  };

  return !isNil(price) ? <div className="amount-field">
    <Grid fluid={true} container={false} rowGap={0} colGap={16} align={'start'} justify={'start'}
      className={className}>
      <GridItem span={7} {...labelSpanConfig} className="amount-field__label">
        <TipText />
        {
          tipId
        && <React.Fragment>
          <Responsive not eqAbove="xl">
            <span
              tabIndex="0"
              role="button"
              aria-labelledby={`field-label__${tipId}`}
              aria-expanded={isShowTipMsg}
              onClick={toggleShowTipMsg}
              onKeyDown={handleKeyboardEvent(toggleShowTipMsg, [ 'Enter', ' ' ])}
              className={classnames('amount-field__tip-icon',
                {
                  'ic-triangle-up': isShowTipMsg,
                  'ic-triangle-down': !isShowTipMsg,
                })}>
            </span>
          </Responsive>
          <Responsive eqAbove="xl">
            <Popover placement={placement || 'top'}
              style={{ zIndex: 9999 }}
              theme="dark"
              content={<div className="amount-field__tip-text">
                <Locale id={tipId} />
              </div>}>
              <span
                aria-haspopup
                role={'button'}
                tabIndex={0}
                aria-label="question-icon-button"
                className="ic-question-r
                amount-field__tip-icon"
                onMouseOver={handleMouseOver}
                onFocus={handleMouseOver}
                data-popover-trigger >
              </span>
            </Popover>
          </Responsive>
        </React.Fragment>
        }
      </GridItem>
      <GridItem span={5} {...valueSpanConfig} className={`amount-field__value${amountStyleClassName}`}>
        <Currency amount={price} code={currencyCode}/>
      </GridItem>
      {isShowBlankCol
      && <Responsive eqAbove="xl">
        <GridItem {...blankColSpanConfig} />
      </Responsive>
      }
    </Grid>
    {
      isShowTipMsg && <Responsive not eqAbove="xl">
        <div className="amount-field__tip-text">
          <Locale id={tipId} />
        </div>
      </Responsive>
    }
  </div> : null;
};

AmountField.propTypes = {
  label: string,
  price: number,
  currencyCode: string,
  className: string,
  tipId: string,
  name: string,
  isShowTipMsg: bool,
  toggleShowTipMsg: func,
  isShowBlankCol: bool,
  labelSpanConfig: object,
  valueSpanConfig: object,
  blankColSpanConfig: object,
};

AmountField.defaultProps = {
  label: undefined,
  price: undefined,
  currencyCode: undefined,
  className: undefined,
  tipId: undefined,
  name: undefined,
  isShowTipMsg: false,
  toggleShowTipMsg: noop,
  isShowBlankCol: false,
  labelSpanConfig: {},
  valueSpanConfig: {},
  blankColSpanConfig: {
    spanMd: 3,
    spanXl: 2,
  },
};

export default AmountField;
